import React, { useState, useEffect } from 'react';

const ChallengeDetailModal = ({
  open,
  onClose,
  challenge,
  onSubmit,
  bountyId,
  mode = 'detail', // 'create' | 'detail' | 'update'
}) => {
  const [editedChallenge, setEditedChallenge] = useState(challenge || {
    name: '',
    type: '',
    bountyId: bountyId,
  });

  useEffect(() => {
    if (challenge) setEditedChallenge(challenge);
    else setEditedChallenge({ name: '', type: '', bountyId });
  }, [challenge, bountyId]);

  if (!open) return null;

  const handleInputChange = (field, value) => {
    setEditedChallenge(prev => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSave = () => {
    if (onSubmit) onSubmit(editedChallenge);
  };

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh',
      background: 'rgba(0,0,0,0.4)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center'
    }}>
      <div style={{
        background: '#fff', borderRadius: 8, width: 480, maxWidth: '90vw', padding: 0, position: 'relative', boxShadow: '0 2px 16px #0004'
      }}>
        <button
          onClick={onClose}
          style={{
            position: 'absolute', top: 16, right: 16, background: 'transparent', border: 'none', fontSize: 24, cursor: 'pointer', zIndex: 2
          }}
        >×</button>
        <div style={{ padding: 32 }}>
          <h2 style={{ marginBottom: 24 }}>
            {mode === 'create' && 'Create New Challenge'}
            {mode === 'update' && 'Update Challenge'}
            {mode === 'detail' && 'Challenge Details'}
          </h2>
          <div style={{ marginBottom: 20 }}>
            <label style={{ fontWeight: 600 }}>Challenge Name *</label>
            <input
              value={editedChallenge.name}
              onChange={e => handleInputChange('name', e.target.value)}
              disabled={mode === 'detail'}
              style={{
                width: '100%',
                padding: 10,
                marginTop: 6,
                border: '1px solid #ccc',
                borderRadius: 6,
                background: mode === 'detail' ? '#f5f5f5' : '#fff'
              }}
            />
          </div>
          <div style={{ marginBottom: 20 }}>
            <label style={{ fontWeight: 600 }}>Type *</label>
            <input
              value={editedChallenge.type}
              onChange={e => handleInputChange('type', e.target.value)}
              disabled={mode === 'detail'}
              style={{
                width: '100%',
                padding: 10,
                marginTop: 6,
                border: '1px solid #ccc',
                borderRadius: 6,
                background: mode === 'detail' ? '#f5f5f5' : '#fff'
              }}
            />
          </div>
          <div style={{ display: 'flex', gap: 8, marginTop: 24, justifyContent: 'flex-end' }}>
            <button
              onClick={onClose}
              style={{
                padding: '8px 16px',
                background: '#f44336',
                color: 'white',
                border: 'none',
                borderRadius: 4,
                cursor: 'pointer'
              }}
            >
              Close
            </button>
            {(mode === 'create' || mode === 'update') && (
              <button
                onClick={handleSave}
                style={{
                  padding: '8px 16px',
                  background: '#4caf50',
                  color: 'white',
                  border: 'none',
                  borderRadius: 4,
                  cursor: 'pointer'
                }}
              >
                Save
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChallengeDetailModal;
